export function moveChildIdBeforeTarget(
  orderedIds: string[],
  movedId: string,
  targetId: string | null
) {
  const remainingIds = orderedIds.filter((id) => id !== movedId);

  if (!targetId || targetId === movedId) {
    return [...remainingIds, movedId];
  }

  const targetIndex = remainingIds.indexOf(targetId);

  if (targetIndex < 0) {
    return [...remainingIds, movedId];
  }

  return [
    ...remainingIds.slice(0, targetIndex),
    movedId,
    ...remainingIds.slice(targetIndex),
  ];
}
